// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/circuit-leaving.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/circuit-leaving/circuit-leaving.js';

mount([g0]);
